import { render, staticRenderFns } from "./WhoAreYou.vue?vue&type=template&id=4fdc3b22&scoped=true&"
import script from "./WhoAreYou.vue?vue&type=script&lang=js&"
export * from "./WhoAreYou.vue?vue&type=script&lang=js&"
import style0 from "./WhoAreYou.vue?vue&type=style&index=0&id=4fdc3b22&scoped=true&lang=css&"
import style1 from "./WhoAreYou.vue?vue&type=style&index=1&id=4fdc3b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc3b22",
  null
  
)

export default component.exports